// import { Button } from '@mui/material'
interface IProps {
    onRefresh: () => void;
    isLoading: boolean;
}

export const SectionNoData = ({ onRefresh, isLoading }: IProps) => {
    return (
        <div style={{ textAlign: 'center', padding: '150px 0px' }}>
            {
                isLoading ? '' : 'No Data Found'
            }
            <br />
            {
                !isLoading ?
                    // <Button
                    //     variant="contained"
                    //     color="success"
                    //     onClick={onRefresh}
                    //     style={{ marginTop: '20px' }}
                    // > Refresh
                    // </Button> : null
                    <button
                        onClick={onRefresh}
                        className="btn btn-primary"
                        style={{ marginTop: '20px' }}
                    >Refresh</button> : null
            }
        </div>
    )
}
